module.exports = __webpack_public_path__ + "static/media/img.59369724.png";